module.exports = __webpack_public_path__ + "static/media/apropos_title.92511e0c.png";